import script from "./CsaApartments.vue?vue&type=script&setup=true&lang=ts"
export * from "./CsaApartments.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__